import React from "react";
import { LegalLayout } from "./LegalLayout";
import { COMPANY } from "@/lib/company";

export default function GizlilikKvkk() {
  return (
    <LegalLayout title="Gizlilik ve KVKK Politikası">
      <p>
        {COMPANY.legalName} ("{COMPANY.brand}") olarak kişisel verilerinizin güvenliğine önem veriyoruz.
        İşbu politika, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında verilerinizin
        nasıl işlendiğini açıklar. Veri sorumlusu {COMPANY.legalName}'dir.
      </p>

      <h2>İşlenen Veriler</h2>
      <ul>
        <li><strong>İşletme/kullanıcı verileri:</strong> ad-soyad, e-posta, telefon, işletme bilgileri.</li>
        <li><strong>Rezervasyon verileri:</strong> son kullanıcıların randevu için girdiği ad ve telefon bilgisi.</li>
        <li><strong>Teknik veriler:</strong> oturum/çerez bilgileri, IP ve kullanım kayıtları.</li>
        <li><strong>Ödeme verileri:</strong> ödemeler PayTR altyapısıyla alınır; kart bilgileri tarafımızca saklanmaz.</li>
      </ul>

      <h2>İşleme Amaçları</h2>
      <ul>
        <li>Hizmetin sunulması, hesabın oluşturulması ve yönetilmesi.</li>
        <li>Rezervasyon süreçlerinin yürütülmesi ve bildirimlerin (e-posta/WhatsApp) gönderilmesi.</li>
        <li>Abonelik ve ödeme işlemlerinin gerçekleştirilmesi, faturalandırma.</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi ve güvenliğin sağlanması.</li>
      </ul>

      <h2>Veri Paylaşımı</h2>
      <p>
        Kişisel verileriniz; ödeme kuruluşu (PayTR), e-posta ve mesajlaşma servis sağlayıcıları ile
        yalnızca hizmetin gerektirdiği ölçüde ve yasal zorunluluklar çerçevesinde paylaşılabilir. Verileriniz
        üçüncü kişilere pazarlama amacıyla satılmaz.
      </p>

      <h2>Çerezler</h2>
      <p>
        Oturumunuzun güvenli şekilde sürdürülmesi için gerekli (httpOnly) çerezler kullanılır. Bu çerezler
        hizmetin çalışması için zorunludur.
      </p>

      <h2>Haklarınız (KVKK m.11)</h2>
      <p>
        Kişisel verilerinize erişme, düzeltilmesini veya silinmesini talep etme ve işlemeye itiraz etme
        haklarına sahipsiniz. Taleplerinizi <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> adresine
        iletebilirsiniz. Başvurularınız en geç 30 gün içinde sonuçlandırılır.
      </p>

      <h2>İletişim</h2>
      <p>{COMPANY.legalName} · {COMPANY.address} · Tel: {COMPANY.phone} · E-posta: {COMPANY.email}</p>
    </LegalLayout>
  );
}
